import {Component, HostBinding, OnInit} from '@angular/core';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {LocalStorageService} from 'ngx-webstorage';
import {EditOrderSaveChangesComponent} from '../../modules/orders/edit/save-changes/save-changes.component';

@Component({
  selector: 'app-footer',
  templateUrl: 'footer.component.html',
  styleUrls: ['footer.component.scss'],
})
export class footerComponent implements OnInit {
  @HostBinding('class.footerHost') hostClass = false;
  currentYear = new Date().getFullYear();
  ngOnInit() {
  }

  constructor(private modalService: NgbModal,
              private localSt: LocalStorageService,) {
    this.hostClass = true;
  }

  termsClick() {
    if (this.localSt.retrieve('orderEditingMore')) {
      this.modalService.open(EditOrderSaveChangesComponent, {backdrop: 'static', keyboard: false}).result.then((response) => {
        if (response) {
          this.localSt.clear('editOrderItems');
          this.localSt.clear('orderEditingMore');
          this.localSt.clear('editOrderAddress');
          window.open('http://zenclassics.com/terms', '_self');
        }
      });
    } else {
      window.open('http://zenclassics.com/terms', '_self');
    }
  }

  privacyClick() {
    if (this.localSt.retrieve('orderEditingMore')) {
      this.modalService.open(EditOrderSaveChangesComponent, {backdrop: 'static', keyboard: false}).result.then((response) => {
        if (response) {
          this.localSt.clear('editOrderItems');
          this.localSt.clear('orderEditingMore');
          this.localSt.clear('editOrderAddress');
          window.open('http://zenclassics.com/privacy-policy', '_self');
        }
      });
    } else {
      window.open('http://zenclassics.com/privacy-policy', '_self');
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/template/footer/footer.component.ts